import { config } from '@abyss/ui/tools/config';
import { useQuery } from '../../tools/useQuery';

const env = `${config('APP_ENV')}`;
const NONPROD_URL = `${config(
  'CORE_PAAN_STARGATE_API_URL'
)}/commons/v1/organizationTypes`;

const PROD_URL = `${config(
  'CORE_PAAN_STARGATE_API_URL'
)}/uhcppaan-commons/v1/organizationTypes`;

const parseResult = result => {
  const initialState = [];

  if (result) {
    return result;
  }

  return initialState;
};

export const usePaanOrgType = options => {
  const queryOptions = options;
  queryOptions.method = 'GET';
  let url = PROD_URL;
  if (env !== 'prod') {
    url = NONPROD_URL;
  }

  const [queryResult, queryAction] = useQuery(url, {
    ...queryOptions,
    onCompleted: result => {
      if (options.onCompleted) {
        options.onCompleted(parseResult(result.body));
      }
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
